import React from 'react';
import { useDebug } from './debug-provider';
import DebugPill from './debug-pill';
const DraftDebug = ({ publishedAt }) => {
    const { showCurrentPublishState } = useDebug();
    if (showCurrentPublishState) {
        return (React.createElement(DebugPill, null, publishedAt ? `Published ${publishedAt}` : 'Not Published'));
    }
    return null;
};
export default DraftDebug;
//# sourceMappingURL=draft-debug.js.map